// extracted by mini-css-extract-plugin
module.exports = {"form":"TypeformWidget_form__MiI_E"};